import { useGameStore } from '@/app/store';
import { AsyncStatus } from '@/shared/lib/async';
import { makeReplayFilter, RemoteGameDriver } from '@/shared/lib/driver';

/**
 * Builds a `RemoteGameDriver` with the replay filter wired to the gameStore.
 *
 * Lives here (not in features/) because the snapshot getter must read the
 * raw store — features are not allowed to import `@/app/store` directly.
 * The filter drops pending-queue frames whose preconditions (phase, target
 * alive) no longer hold by the time the socket reopens, cutting stale
 * server `Error` responses that pollute analytics.
 */
export const createOnlineDriver = (
  roomId: string,
  getToken: () => string | null,
  baseUrl: string,
  setToken: (token: string) => void,
): RemoteGameDriver =>
  new RemoteGameDriver(
    roomId,
    getToken,
    baseUrl,
    setToken,
    makeReplayFilter(() => {
      const room = useGameStore.getState().room;
      if (room.status !== AsyncStatus.Ready) return null;
      return { phase: room.data.phase, players: room.data.players };
    }),
  );
